'use client';

import type { KeyboardEvent } from 'react';
import { useTranslations } from 'next-intl';
import { Box, HStack, VStack } from '@terra/ui-styled-system';
import { MetaDefault } from '../../../../../components/typography';
import { Textarea } from '../../../../../components/styled/textarea';
import { Button } from '../../../../../components/styled/button';

type HitlRejectFormProps = {
  actionName: string;
  message: string;
  onMessageChange: (message: string) => void;
  onCancel: () => void;
  onSkip: () => void;
  onSubmit: () => void;
  onKeyDown?: (event: KeyboardEvent<HTMLTextAreaElement>) => void;
};

export function HitlRejectForm({
  actionName,
  message,
  onMessageChange,
  onCancel,
  onSkip,
  onSubmit,
  onKeyDown,
}: HitlRejectFormProps) {
  const t = useTranslations(
    'designSystem.chat.hitlRequestConfirmationPromptCard',
  );

  return (
    <Box w="full" borderTopWidth="1px" borderColor="border.subtle" pt={3}>
      <VStack gap={2} w="full">
        <MetaDefault color="fg.muted">
          {t('rejectDescription', { actionName })}
        </MetaDefault>
        <Textarea
          placeholder={t('rejectPlaceholder')}
          value={message}
          onChange={(e) => onMessageChange(e.target.value)}
          onKeyDown={onKeyDown}
          rows={2}
          resize="vertical"
          fontSize="xs"
          autoFocus
        />
        <HStack gap={2} justifyContent="flex-end" w="full">
          <Button variant="ghost" size="xs" onClick={onCancel}>
            {t('cancel')}
          </Button>
          <Button variant="ghost" size="xs" onClick={onSkip}>
            {t('skipMessage')}
          </Button>
          <Button variant="outline" size="xs" onClick={onSubmit}>
            {t('reject')}
          </Button>
        </HStack>
      </VStack>
    </Box>
  );
}
